module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.consumerName) ? [(!_vm.isLmrConsumer) ? _c('Details') : _vm._e(), _vm._v(" "), (_vm.$store.state.consumerGroup == 'ebra') ? _c('div', [_c('div', {
    staticClass: "marker-details"
  }, [(_vm.showVideos) ? _c('h3', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.$tc('records.video', 2)))]) : _vm._e(), _vm._v(" "), (_vm.showImages) ? _c('h3', {
    staticClass: "highlight"
  }, [_vm._v("Images")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "records-information row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.records.length && !_vm.isLmrConsumer) ? _c('p', [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("\n              " + _vm._s(_vm.records.length) + " " + _vm._s(_vm.$tc('records.video', _vm.records.length >= 2 ? 2 : 1)) + "\n            ")]), _vm._v("\n            " + _vm._s(_vm.$tc('records.has_been_recorded', _vm.records.length >= 2 ? 2 : 1)) + "\n            "), (_vm.diversityTree) ? _c('span', [_c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "title": "show dendrogram"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showTree = !_vm.showTree
      }
    }
  }, [_c('img', {
    staticStyle: {
      "height": "16px",
      "cursor": "pointer",
      "opacity": "0.7"
    },
    attrs: {
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAALuSURBVHhe7dw9aFRBFMXx1SiCiAgiCBpBUPGrtBA7G5s0NqlsLG2tg42VlY32NlZ+YGNjY2GjYGkhWAiCEBC/RRBJ1HPhFctyJmPeuzOTvHt+8K/cLOQmuW72Td5ERERERERERERk5ObRA/Qd/R2YPcdDdBTJfziIPiE2zCHZc9pzS8Z9xAbo0T0kGT8QG55H35BksMF5JhlsaJ5JBhuaZ5LBhuaZZLCheSZr2I3Y0DyThNPoDWJD80yIy+gnYgPzTqbsRHcQG1SppHMcvUJsSCUTuIRKvuWwVqHtQLcRG0ytwjqMXiI2lJqFdBF9QWwgtQtlO7qJ/iA2jBaFYZcVnyM2hFQ1fhcI4QL6gNgAUr1G9tuwx3XgVKO/IDOHrqNVxAaQ6i7ahYxdQGeP8cgu9I/WfvQUsU881S90BU07hj4j9vgh2XMeQaN0Hi0j9omneovOIOYAsgvotjLYx66nr8i+86sO3/tcjQ2DHenYgpbQCmIfm+oR2oNGqdS5mo9o+ouwFz1G7LGpfqOryL5wo1XyXI09tzmL3iH2mFTv0Tk0eiXf5LJ1ZN/B9p3M/j3VE7QPhcAG0Cr7v+Ea2orCYINokb0qsldH4bBh1O4ZspeSIbGB1MredLuBtqGw2GBqZC9TF1B4bDile4EOIQE2oJLdQnapUTpsSCWy92kWkcxgwyqRXTyxA1Uygw2rZHawyg5YSYcNqXR2wOoEEmADqpFWUocNp2bhVxIbSu1CryQ2kBaFXUlsGC0Lt5JKn6vp88cUtpJOohBqnKuxA1TrPdsfZiXVOlfT969bQqykmudq+q6kU0iceK8k3S+oB6+VpPsFDdR3JdlPkdH9ghwMWUm6X5CTviupdOH0WUklC6nPSipVWBtlJYXXeiUJtFxJ0mm1kmRG7ZUkRM2VJAm1VpJksKF5JhlsaJ5JBhuaZ5LBhuaZZLCheSYZbGieSUbpc02SofsFNab7BW0Am/5+QSIiIiIiIiIistlMJv8AOUZozSTDIV4AAAAASUVORK5CYII=",
      "alt": "dendrogram"
    }
  })])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showTree) ? _c('dendrogram', {
    staticClass: "dendrogram",
    attrs: {
      "root": _vm.diversityTree
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "records"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.newVideosCount > 0) ? _c('div', {
    staticClass: "alert new-record-avaible"
  }, [_c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.newVideosCount))]), _vm._v("\n            " + _vm._s(_vm.$tc('records.new_available', _vm.newVideosCount >= 2 ? 2 : 1)) + "\n            "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.swapInNewRecords()
      }
    }
  }, [_vm._v(_vm._s(_vm.$tc('records.click_here_to_refresh')))])]) : _vm._e()]), _vm._v(" "), (_vm.$root.$children[0].$data.clientId != 'digiteka') ? _c('div', {
    staticClass: "row"
  }, [(!_vm.$store.state.editorConsumers[0]) ? _c('lmr-city-report-filter', {
    staticClass: "col-md-6",
    on: {
      "change": _vm.handleLmrCitySelected
    },
    model: {
      value: (_vm.recordFilters.lmr_cities),
      callback: function($$v) {
        _vm.$set(_vm.recordFilters, "lmr_cities", $$v)
      },
      expression: "recordFilters.lmr_cities"
    }
  }) : _c('editor-consumer-filter', {
    staticClass: "col-md-6",
    on: {
      "change": _vm.handleEditorConsumerSelected
    },
    model: {
      value: (_vm.recordFilters.editor_consumers),
      callback: function($$v) {
        _vm.$set(_vm.recordFilters, "editor_consumers", $$v)
      },
      expression: "recordFilters.editor_consumers"
    }
  }), _vm._v(" "), _c('marker-tags-selector', {
    ref: "tagsFilter",
    staticClass: "col-md-6",
    attrs: {
      "markerId": _vm.markerId
    },
    on: {
      "tags-selected": _vm.handleTagsSelected
    }
  })], 1) : _c('div', {
    staticClass: "row"
  }, [_c('lmr-city-report-filter', {
    staticClass: "col-md-12",
    on: {
      "change": _vm.handleLmrCitySelected
    },
    model: {
      value: (_vm.recordFilters.lmr_cities),
      callback: function($$v) {
        _vm.$set(_vm.recordFilters, "lmr_cities", $$v)
      },
      expression: "recordFilters.lmr_cities"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('v-autocomplete', {
    ref: "filterByAuthor",
    staticClass: "col-md-6 order_list",
    attrs: {
      "items": _vm.filtersAuthors,
      "rules": [function () { return !!_vm.recordFilters.user || _vm.$t('upload_video.field_is_required'); }],
      "loading": _vm.isLoadingAuthors,
      "search-input": _vm.searchFilteredUser,
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "autocomplete_full_name",
      "item-value": "pk",
      "placeholder": _vm.$t('user.filter.filter_by_user'),
      "return-object": "",
      "outline": "",
      "clearable": "",
      "single-line": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.searchFilteredUser = $event
      },
      "update:search-input": function($event) {
        _vm.searchFilteredUser = $event
      },
      "input": _vm.fetchRecords
    },
    model: {
      value: (_vm.recordFilters.user),
      callback: function($$v) {
        _vm.$set(_vm.recordFilters, "user", $$v)
      },
      expression: "recordFilters.user"
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "col-md-6 right order_list",
    attrs: {
      "placeholder": _vm.$t('Ordering'),
      "items": _vm.itemsOrdering,
      "flat": "",
      "outline": "",
      "single-line": ""
    },
    on: {
      "input": _vm.fetchRecords
    },
    model: {
      value: (_vm.recordOrdering),
      callback: function($$v) {
        _vm.recordOrdering = $$v
      },
      expression: "recordOrdering"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.isLmrConsumer) ? _c('lmr-category-filter', {
    staticClass: "col-md-6",
    on: {
      "change": _vm.fetchRecords
    },
    model: {
      value: (_vm.recordFilters.lmr_category),
      callback: function($$v) {
        _vm.$set(_vm.recordFilters, "lmr_category", $$v)
      },
      expression: "recordFilters.lmr_category"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.consumer_group === 'ebra') ? _c('v-select', {
    staticClass: "col-md-6 right order_list",
    attrs: {
      "placeholder": _vm.$t('departments.filter_by_department'),
      "items": _vm.departments,
      "flat": "",
      "outline": "",
      "single-line": ""
    },
    on: {
      "input": _vm.fetchRecords
    },
    model: {
      value: (_vm.department),
      callback: function($$v) {
        _vm.department = $$v
      },
      expression: "department"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.consumer_group === 'rossel') ? _c('sdk-filter', {
    on: {
      "change": _vm.fetchRecords
    },
    model: {
      value: (_vm.recordFilters.sdk_record),
      callback: function($$v) {
        _vm.$set(_vm.recordFilters, "sdk_record", $$v)
      },
      expression: "recordFilters.sdk_record"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-tabs', {
    attrs: {
      "fixed-tabs": "",
      "slider-color": "#ff2d55"
    },
    model: {
      value: (_vm.activeTabIndex),
      callback: function($$v) {
        _vm.activeTabIndex = $$v
      },
      expression: "activeTabIndex"
    }
  }, [_c('v-tab', [_vm._v("\n            " + _vm._s(_vm.$t('new')) + " "), (_vm.newTabRecordsCount) ? _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.newTabRecordsCount))]) : _vm._e()]), _vm._v(" "), _c('v-tab', {
    attrs: {
      "id": "approved_tab"
    }
  }, [_vm._v(_vm._s(_vm.$t('approved')))]), _vm._v(" "), _c('v-tab', [_vm._v(_vm._s(_vm.$t('deleted')))])], 1), _vm._v(" "), (_vm.activeTabIndex === _vm.recordTabs.new && _vm.isLmrConsumer) ? _c('div', {
    attrs: {
      "id": "select-mode-btn-wrapper"
    }
  }, [(_vm.records.length) ? _c('button', {
    staticClass: "btn btn-default highlight mr-1",
    class: {
      active: _vm.approveMode
    },
    attrs: {
      "id": "select-mode-btn",
      "department": ""
    },
    on: {
      "click": _vm.toggleApproveMode
    }
  }, [_vm._v(_vm._s(_vm.$t('approve').toUpperCase()))]) : _vm._e(), _vm._v(" "), (_vm.showVideos && _vm.records.length > 1) ? _c('button', {
    staticClass: "btn btn-default highlight",
    class: {
      active: _vm.mergeMode
    },
    attrs: {
      "id": "merge-mode-btn"
    },
    on: {
      "click": _vm.toggleMergeMode
    }
  }, [_vm._v(_vm._s(_vm.$t('merge').toUpperCase()))]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), [(!_vm.videoFileUploading && !_vm.showImages) ? _c('button', {
    staticClass: "btn btn-default highlight right",
    attrs: {
      "id": "add-video-mode-btn"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialog = true
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('upload_video.upload_video_title').toUpperCase()) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t('upload_video.upload_video_title')))])]), _vm._v(" "), (_vm.videoFileUploading) ? _c('v-card-text', [_c('v-container', {
    staticStyle: {
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "subtitle-1 text-center",
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('upload_video.upload_progress')) + " (" + _vm._s(_vm.bufferVideoUploading) + "%)\n          ")]), _vm._v(" "), _c('v-progress-linear', {
    attrs: {
      "buffer-value": 100,
      "color": "#ff2d55",
      "bufferVideoUploading": "",
      "height": "6"
    },
    model: {
      value: (_vm.bufferVideoUploading),
      callback: function($$v) {
        _vm.bufferVideoUploading = $$v
      },
      expression: "bufferVideoUploading"
    }
  })], 1)], 1) : _c('v-card-text', [(!_vm.uploadingVideoFile) ? _c('div', [_c('div', {
    class: ['dropZone', _vm.dragging ? 'dropZone-over' : ''],
    on: {
      "dragenter": function($event) {
        _vm.dragging = true
      },
      "dragleave": function($event) {
        _vm.dragging = false
      }
    }
  }, [_c('div', {
    staticClass: "dropZone-info",
    on: {
      "drag": _vm.onChange
    }
  }, [_c('span', {
    staticClass: "fa fa-cloud-upload dropZone-title"
  }), _vm._v(" "), _c('span', {
    staticClass: "dropZone-title"
  }, [_vm._v(_vm._s(_vm.$t('upload_video.drop_file_or_click')))]), _vm._v(" "), _c('div', {
    staticClass: "dropZone-upload-limit-info"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('upload_video.support_file')))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('upload_video.max_file_size')) + ": 500 MB")]), _vm._v(" "), (_vm.uploadVideoFormHasErrors) ? _c('div', [_vm._v(_vm._s(_vm.$t('upload_video.you_must_add_video_file')))]) : _vm._e()])]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onChange
    }
  })])]) : _c('div', {
    staticClass: "dropZone-uploaded"
  }, [_c('div', {
    staticClass: "dropZone-uploaded-info"
  }, [_c('span', {
    staticClass: "dropZone-title"
  }, [_vm._v(_vm._s(_vm.$t('upload_video.checked')))]), _vm._v(" "), _c('div', {
    staticClass: "uploadedFile-info"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('upload_video.file_name')) + ": " + _vm._s(_vm.uploadingVideoFile.name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('upload_video.file_size')) + ": " + _vm._s((_vm.uploadingVideoFile.size / 1000000).toFixed(2)) + " MB")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('upload_video.extension')) + ": " + _vm._s(_vm.extension))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary removeFile",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.removeFile
    }
  }, [_vm._v(_vm._s(_vm.$t('upload_video.remove_file')))])])]), _vm._v(" "), _c('div', [_c('v-radio-group', {
    ref: "typeVideoUpload",
    attrs: {
      "row": "",
      "rules": [function () { return !!_vm.typeVideoUpload || _vm.$t('upload_video.field_is_required'); }]
    },
    model: {
      value: (_vm.typeVideoUpload),
      callback: function($$v) {
        _vm.typeVideoUpload = $$v
      },
      expression: "typeVideoUpload"
    }
  }, _vm._l((_vm.videoUploadTypes), function(item) {
    return _c('v-radio', {
      key: item.id,
      attrs: {
        "color": "rgb(255, 45, 85)",
        "label": item.name,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('v-autocomplete', {
    ref: "uploadVideoAuthor",
    attrs: {
      "items": _vm.entriesAuthors,
      "rules": [function () { return !!_vm.uploadVideoAuthor || _vm.$t('upload_video.field_is_required'); }],
      "loading": _vm.isLoadingAuthors,
      "search-input": _vm.search,
      "color": "#ff2d55",
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "autocomplete_full_name",
      "item-value": "pk",
      "placeholder": _vm.$t('upload_video.start_typing'),
      "return-object": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.search = $event
      },
      "update:search-input": function($event) {
        _vm.search = $event
      }
    },
    model: {
      value: (_vm.uploadVideoAuthor),
      callback: function($$v) {
        _vm.uploadVideoAuthor = $$v
      },
      expression: "uploadVideoAuthor"
    }
  }), _vm._v(" "), _c('v-text-field', {
    ref: "titleVideoUpload",
    attrs: {
      "rules": [function () { return !!_vm.titleVideoUpload || _vm.$t('upload_video.field_is_required'); }],
      "color": "#ff2d55",
      "counter": 100,
      "label": _vm.$t('upload_video.title'),
      "required": ""
    },
    model: {
      value: (_vm.titleVideoUpload),
      callback: function($$v) {
        _vm.titleVideoUpload = $$v
      },
      expression: "titleVideoUpload"
    }
  }), _vm._v(" "), (_vm.consumerHasDescriptionField) ? _c('v-textarea', {
    ref: "descriptionVideoUpload",
    attrs: {
      "rules": [function () { return !!_vm.descriptionVideoUpload || _vm.$t('upload_video.field_is_required'); }],
      "color": "#ff2d55",
      "name": "input-7-1",
      "label": _vm.$t('upload_video.description'),
      "value": "",
      "hint": "Hint text"
    },
    model: {
      value: (_vm.descriptionVideoUpload),
      callback: function($$v) {
        _vm.descriptionVideoUpload = $$v
      },
      expression: "descriptionVideoUpload"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('v-card-actions', {
    staticStyle: {
      "padding": "16px"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "#ff2d55",
      "outline": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('upload_video.close')))]), _vm._v(" "), (!_vm.videoFileUploading) ? _c('v-btn', {
    attrs: {
      "color": "#ff2d55",
      "outline": ""
    },
    on: {
      "click": _vm.uploadData
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('upload_video.upload')))]) : _vm._e()], 1)], 1)], 1)]], 2) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading && !_vm.records.length),
      expression: "loading && !records.length"
    }],
    staticClass: "loading-indicator center-block"
  }), _vm._v(" "), (!_vm.records.length && !_vm.loading) ? _c('p', {
    staticClass: "empty"
  }, [_vm._v("\n          " + _vm._s(_vm.$t("records.none_available")) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('records-list', {
    attrs: {
      "records": _vm.records,
      "marker-id": _vm.markerId,
      "selectedRecords": _vm.selectedRecords,
      "showSelectIndex": _vm.mergeMode,
      "isChoosingMode": _vm.approveMode || _vm.mergeMode || _vm.downloadMode
    },
    on: {
      "delete-record": _vm.handleRecordDelete,
      "restore-record": _vm.handleRecordRestore,
      "mark-record-relevance": _vm.markRecordRelevance,
      "clicked-record": _vm.recordClicked
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.amountOfPages > 1),
      expression: "amountOfPages > 1"
    }]
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.amountOfPages,
      "total-visible": 10
    },
    on: {
      "input": function($event) {
        _vm.records = [];
        _vm.fetchRecords()
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1), _vm._v(" "), (_vm.mergeMode || _vm.approveMode || _vm.downloadMode) ? _c('div', {
    staticStyle: {
      "margin-bottom": "100px"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.approveMode) ? _c('div', {
    staticClass: "select-mode-bar"
  }, [_c('div', {
    staticClass: "container"
  }, [(!_vm.showImages) ? _c('button', {
    staticClass: "btn btn-info left",
    attrs: {
      "disabled": !_vm.selectedRecords.length
    },
    on: {
      "click": _vm.downloadRecords
    }
  }, [_vm._v(_vm._s(_vm.$t('download').toUpperCase()) + " (" + _vm._s(_vm.selectedRecords.length) + ")")]) : _vm._e(), _vm._v(" "), (_vm.showImages) ? _c('button', {
    staticClass: "btn btn-info left",
    attrs: {
      "disabled": !_vm.selectedRecords.length
    },
    on: {
      "click": _vm.downloadRecordsZip
    }
  }, [_vm._v(_vm._s(_vm.$t('download').toUpperCase()) + " (" + _vm._s(_vm.selectedRecords.length) + ")")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger left",
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.toggleApproveMode
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel').toUpperCase()))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": !_vm.selectedRecords.length
    },
    on: {
      "click": _vm.rejectRecords
    }
  }, [_vm._v(_vm._s(_vm.$t('reject').toUpperCase()) + " (" + _vm._s(_vm.selectedRecords.length) + ")")]), _vm._v(" "), (!_vm.showImages) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": !_vm.selectedRecords.length
    },
    on: {
      "click": _vm.approveRecords
    }
  }, [_vm._v(_vm._s(_vm.$t('records.approve').toUpperCase()) + " (" + _vm._s(_vm.selectedRecords.length) + ")")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.mergeMode) ? _c('div', {
    staticClass: "select-mode-bar"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('button', {
    staticClass: "btn btn-danger left",
    on: {
      "click": _vm.toggleMergeMode
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel').toUpperCase()))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": !(_vm.selectedRecords.length > 1)
    },
    on: {
      "click": function($event) {
        return _vm.setMergeRecordTitle(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('merge').toUpperCase()) + " (" + _vm._s(_vm.selectedRecords.length) + ")")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": !(_vm.selectedRecords.length > 1)
    },
    on: {
      "click": function($event) {
        return _vm.setMergeRecordTitle(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('merge_abd_approve').toUpperCase()) + " (" + _vm._s(_vm.selectedRecords.length) + ")")])])]) : _vm._e(), _vm._v(" "), (_vm.selectedRecord) ? _c('record-details', {
    attrs: {
      "record": _vm.selectedRecord
    },
    on: {
      "clicked-similar-record": _vm.showRecordDetails,
      "close": function($event) {
        _vm.selectedRecord = null
      },
      "cut-started": _vm.setCutIcon
    }
  }) : _vm._e(), _vm._v(" "), (_vm.relatedRecords.length > 0) ? [_c('div', {
    staticClass: "records-information related-records row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$tc('records.related_streams_title')))]), _vm._v(" "), _c('p', {
    staticClass: "help-block"
  }, [_c('em', [_vm._v("\n                " + _vm._s(_vm.$tc('records.related_streams_help')) + "\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "records related-records row"
  }, [_c('records-list', {
    attrs: {
      "records": _vm.relatedRecords,
      "read-only": true
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.showPremergeModal) ? _c('modal', {
    attrs: {
      "show": _vm.showPremergeModal,
      "okBtnText": _vm.$t('records.start_merge')
    },
    on: {
      "ok": _vm.mergeRecords,
      "hide": _vm.toggleMergeMode
    }
  }, [_c('template', {
    slot: "body"
  }, [_c('div', {
    staticClass: "edit-record-notes form-group"
  }, [(_vm.consumerHasDescriptionField) ? _c('div', {
    staticClass: "form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mergeData.title),
      expression: "mergeData.title"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "record-title",
      "rows": "8",
      "cols": "80"
    },
    domProps: {
      "value": (_vm.mergeData.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.mergeData, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mergeData.description),
      expression: "mergeData.description"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "record-description",
      "rows": "8",
      "cols": "80"
    },
    domProps: {
      "value": (_vm.mergeData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.mergeData, "description", $event.target.value)
      }
    }
  })]) : _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mergeData.title),
      expression: "mergeData.title"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "record-comment",
      "rows": "8",
      "cols": "80"
    },
    domProps: {
      "value": (_vm.mergeData.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.mergeData, "title", $event.target.value)
      }
    }
  })])])])], 2) : _vm._e()], 2)] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-408d206c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/individual_records/IndividualRecords.vue
// module id = 1035
// module chunks = 1